import React, {Component} from "react";
import LinksContainer from "../../components/linkelement/LinksContainer";
import LinkCard from "../../components/linkelement/LinkCard";

class GemLinksAusschuss extends Component {

  render() {

    return <LinksContainer mainTagTitle='Ausschuss' title='Freikirche der Siebenten-Tags-Adventisten Gemeinde Langau i.E.' width='140px' subtitle='Zugang zur DSV-Cloud — Wähle eine Kachel.'>
      <LinkCard link='https://cloud.adventisten.ch/s/Z6c6DZ2Za85Aj3B' numOfColumns='1' title='Ausschuss' subtitle='zu Bereich Ausschuss' description='Hier findest du den Bereich für die Ausschuss-Mitglieder.' />
      <LinkCard link='https://cloud.adventisten.ch/s/fcay2eSBEL4nTCM' numOfColumns='1' title='Ausschuss' subtitle='zu Bereich Glieder' description='Hier findest du den Bereich für die Gemeinde-Glieder.' />
      <LinkCard link='https://cloud.adventisten.ch/s/rsJ46bmiqnaM6eW' numOfColumns='1' title='Ausschuss' subtitle='zu Bereich Gäste' description='Hier findest du den Bereich für die Gäste.' />
      <LinkCard link='https://cloud.adventisten.ch/s/94eSMTbQ2LrP46Z' numOfColumns='1' title='Ausschuss' subtitle='zu Temporärem Ordner' description='Hier kannst du Temporär Daten hochladen und downloaden.' />
    </LinksContainer>;
  }
}

export default GemLinksAusschuss;
